export default __webpack_public_path__ + "static/media/evas03.696fb071.jpg";